import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subject, takeUntil } from 'rxjs';
import { SegmentImportResponse } from '../../../models/segment.model';
import { SegmentService } from '../../../services/segment-api.service';
import { ToastService } from '../../../../../shared/services/toast.service';

@Component({
  selector: 'app-segment-import-section',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './segment-import-section.component.html',
})
export class SegmentImportSectionComponent implements OnDestroy {
  @Input() segmentId: number = 0;
  @Output() imported = new EventEmitter<void>();

  isModalOpen = false;
  isImporting = false;
  importFile: File | null = null;
  importResult: SegmentImportResponse | null = null;
  error: string | null = null;

  private readonly destroy$ = new Subject<void>();

  constructor(
    private segmentApi: SegmentService,
    private toast: ToastService,
  ) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  openModal(): void {
    this.importFile = null;
    this.importResult = null;
    this.error = null;
    this.isModalOpen = true;
  }

  closeModal(): void {
    this.isModalOpen = false;
    this.importFile = null;
    this.importResult = null;
    this.error = null;
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) return;
    const file = input.files[0];
    const ext = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
    if (['.csv', '.xls', '.xlsx'].includes(ext)) {
      this.importFile = file;
      this.error = null;
    } else {
      this.importFile = null;
      this.error = 'Formato no válido. Use CSV o XLSX.';
    }
  }

  ejecutarImport(): void {
    if (!this.importFile) return;
    this.isImporting = true;
    this.importResult = null;

    this.segmentApi.importMembers(this.segmentId, this.importFile)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          this.importResult = res;
          this.isImporting = false;
          this.imported.emit();
        },
        error: () => {
          this.isImporting = false;
          this.toast.error({ title: 'Error', message: 'No se pudo importar el archivo. Intenta de nuevo.' });
        },
      });
  }
}
